import { EmailUnsubscribePage as Page } from "apps/emailUnsubscribe/Page";

export default Page;
